import { bootstrap } from "./modules/bootstrap"

export default class {
  /**
   * @var string
   */
  protected action
  protected method

  /**
   * @var HTMLFormElement
   */
  protected form

  /**
   * @constructor
   */
  public constructor(formId: string, action: string, method: string = "post") {
    this.form = document.getElementById(formId)
    if (this.form) {
      this.action = action
      this.method = method
      this.submit()
    }
  }

  /**
   * 送信イベント
   * @returns {void}
   */
  private submit(): void {
    this.form.addEventListener("submit", (event: SubmitEvent) => {
      this.resetValidationError()
      event.preventDefault()
      const formData = new FormData(
        event.target instanceof HTMLFormElement ? event.target : null
      )
      formData.append("action", this.action)
      this.send(formData)
    })
  }

  /**
   * Ajax
   * @param FormData formData
   * @returns {void}
   */
  private send(formData: FormData): void {
    const ajaxUrl = document.getElementById("ajax-url")
    if (!(ajaxUrl instanceof HTMLInputElement)) {
      return
    }
    const xhr: XMLHttpRequest = new XMLHttpRequest()
    xhr.open(this.method, ajaxUrl.value)
    xhr.setRequestHeader("enctype", "multipart/form-data")
    xhr.addEventListener("load", (event: ProgressEvent) => {
      try {
        const response: any[] = JSON.parse(xhr.response)
        switch (xhr.status) {
          case 200:
            this.success(xhr, response)
            break
          case 422:
            this.invalid(xhr, response)
            break

          default:
            this.failed(xhr, response)
            break
        }
      } catch (error) {
        this.toast("danger", "失敗しました")
      }
    })

    xhr.send(formData)
  }

  /**
   * 送信成功
   * @param XMLHttpRequest xhr
   * @param keyable response
   * @returns {void}
   */
  private success(xhr: XMLHttpRequest, response: keyable): void {
    this.toast("success", response.message)
    this.resetForm()
    window.scrollTo(0, 0)
  }

  /**
   * バリデーションエラー
   * @param XMLHttpRequest xhr
   * @param keyable response
   * @returns {void}
   */
  private invalid(xhr: XMLHttpRequest, response: keyable): void {
    Object.keys(response.errors).forEach((key) => {
      const formControl: HTMLElement = this.form.querySelector(
        '[data-form-validation="' + key + '"]'
      )
      if (formControl) {
        this.showValidationError(formControl, key, response.errors[key])
      }
    })
    this.toast("danger", response.message)
  }

  /**
   * 送信失敗
   * @param XMLHttpRequest xhr
   * @param keyable response
   * @returns {void}
   */
  private failed(xhr: XMLHttpRequest, response: keyable): void {
    this.toast("danger", response.message)
  }

  /**
   * フォームの初期化
   * @returns {void}
   */
  private resetForm(): void {
    this.form.reset()
    this.resetValidationError()
  }

  /**
   * バリデーションエラーの初期化
   * @returns {void}
   */
  private resetValidationError(): void {
    this.form
      .querySelectorAll(".invalid-feedback-switch, invalid-feedback")
      .forEach((element) => {
        element.remove()
      })
    this.form.querySelectorAll(".is-invalid").forEach((element) => {
      element.classList.remove("is-invalid")
    })
  }

  /**
   * バリデーションエラーの表示
   * @param HTMLElement formControl
   * @param string key
   * @param string message
   * @return void
   */
  private showValidationError(
    formControl: HTMLElement,
    key: string,
    message: string
  ): void {
    formControl.appendChild(this.makeInvalidHidden())
    formControl.appendChild(this.makeInvalidFeedback(message))
    const input: HTMLElement = this.form.querySelector('[name="' + key + '"]')
    input.classList.add("is-invalid")
  }

  /**
   * @return {HTMLInputElement}
   */
  private makeInvalidHidden(): HTMLInputElement {
    const input = document.createElement("input")
    input.type = "hidden"
    input.classList.add("is-invalid", "invalid-feedback-switch")
    return input
  }

  /**
   * @param string message
   * @return {HTMLElement}
   */
  private makeInvalidFeedback(message: string): HTMLElement {
    const div = document.createElement("div")
    div.classList.add("invalid-feedback")
    div.innerText = message
    return div
  }

  /**
   * @param string status
   * @param string message
   * @returns {void}
   */
  protected toast(status: string, message: string): void {
    const template: HTMLElement = document.getElementById("template-toast")
    if (!(template instanceof HTMLTemplateElement)) {
      return
    }
    // templateからトーストを作成
    const div: HTMLElement = document.createElement("div")
    div.appendChild(template.content.firstElementChild.cloneNode(true))
    const toast: HTMLElement = div.querySelector(".toast")
    const toastBody: HTMLElement = toast.querySelector(".toast-body")
    toast.classList.add("bg-" + status)
    toastBody.innerText = message
    document.getElementById("toast-box").appendChild(toast)
    // トーストの設置
    document.querySelectorAll(".toast").forEach((element: Element) => {
      element.addEventListener("hidden.bs.toast", (event: Event) => {
        element.remove()
      })
      new bootstrap.Toast(element).show()
    })
  }
}
